// import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
// import { toast } from "react-hot-toast";
// import { authService } from "./userService";

// // Async Thunks
// export const registerUser = createAsyncThunk(
//   "auth/register",
//   async (userData, thunkAPI) => {
//     try {
//       return await authService.register(userData);
//     } catch (error) {
//       const errorMessage =
//         error.response?.data?.message || error.message || "Registration failed";
//       return thunkAPI.rejectWithValue(errorMessage);
//     }
//   }
// );

// export const loginUser = createAsyncThunk(
//   "auth/login",
//   async (userData, thunkAPI) => {
//     try {
//       console.log("🔐 Starting loginUser thunk...");
//       console.log("📨 Received userData:", userData);

//       const response = await authService.login(userData);
//       console.log("✅ Login successful, response:", response);

//       localStorage.setItem("customer", JSON.stringify(response));
//       console.log("💾 Saved user to localStorage");

//       const localCart = JSON.parse(localStorage.getItem("cart")) || [];
//       console.log("🛒 Retrieved localCart from localStorage:", localCart);

//       if (localCart.length > 0) {
//         console.log("🔁 Syncing localCart to server...");
//         for (const item of localCart) {
//           console.log("📦 Adding item to server cart:", item);
//           await thunkAPI.dispatch(addProdToCart(item)).unwrap();
//           console.log("✅ Item added to server cart:", item);
//         }
//         localStorage.removeItem("cart");
//         console.log("🧹 Removed localCart from localStorage after sync");
//       }

//       console.log("📥 Fetching user cart and wishlist from server...");
//       await Promise.all([
//         thunkAPI.dispatch(getUserCart()).unwrap(),
//         thunkAPI.dispatch(getUserProductWishlist()).unwrap(),
//       ]);

//       // Get the normalized wishlist from the Redux store
//       const state = thunkAPI.getState();
//       const normalizedWishlist = state.auth.wishlist;
//       console.log("💖 Normalized wishlist from store:", normalizedWishlist);

//       const result = {
//         user: response,
//         cart: state.auth.cartProducts, // Use normalized cart from store
//         wishlist: normalizedWishlist, // Use normalized wishlist from store
//       };
//       console.log("🎯 Final payload to return:", result);

//       return result;
//     } catch (error) {
//       const errorMessage =
//         error?.response?.data?.message || error?.message || "Login failed";
//       console.error("❌ loginUser Thunk - Error:", errorMessage);
//       return thunkAPI.rejectWithValue(errorMessage);
//     }
//   }
// );

// export const addProdToCart = createAsyncThunk(
//   "user/cart/add",
//   async (cartData, thunkAPI) => {
//     try {
//       const response = await authService.addToCart(cartData);
//       await thunkAPI.dispatch(getUserCart()).unwrap();
//       return response;
//     } catch (error) {
//       const errorMessage =
//         error.response?.data?.message || error.message || "Failed to add to cart";
//       return thunkAPI.rejectWithValue(errorMessage);
//     }
//   }
// );

// export const getUserCart = createAsyncThunk(
//   "user/cart/get",
//   async (_, thunkAPI) => {
//     try {
//       const cartData = await authService.getCart();
//       console.log("getUserCart Thunk - Cart Data:", cartData);
//       return cartData;
//     } catch (error) {
//       console.log(error);
      
//     }
//   }
// );

// export const getUserProductWishlist = createAsyncThunk(
//   "user/wishlist",
//   async (_, thunkAPI) => {
//     try {
//       const wishlistData = await authService.getUserWishlist();
//       console.log("getUserProductWishlist Thunk - Wishlist Data:", wishlistData);
//       return wishlistData;
//     } catch (error) {
//       console.log(error);
      
//     }
//   }
// );

// export const updateCartQuantity = createAsyncThunk(
//   "user/cart/updateQuantity",
//   async ({ cartItemId, quantity }, thunkAPI) => {
//     try {
//       const response = await authService.updateCartQuantity({ cartItemId, quantity });
//       await thunkAPI.dispatch(getUserCart()).unwrap();
//       return response;
//     } catch (error) {
//       const errorMessage =
//         error.response?.data?.message || error.message || "Failed to update cart quantity";
//       return thunkAPI.rejectWithValue(errorMessage);
//     }
//   }
// );

// // Initial State
// const getCustomerFromLocalStorage = localStorage.getItem("customer")
//   ? JSON.parse(localStorage.getItem("customer"))
//   : null;

// const initialState = {
//   user: getCustomerFromLocalStorage,
//   isAuthenticated: !!getCustomerFromLocalStorage,
//   cartProducts: [],
//   wishlist: [],
//   isError: false,
//   isSuccess: false,
//   isLoading: false,
//   message: "",
// };

// export const authSlice = createSlice({
//   name: "auth",
//   initialState,
//   reducers: {
//     logout: (state) => {
//       localStorage.removeItem("customer");
//       state.user = null;
//       state.isAuthenticated = false;
//       state.cartProducts = [];
//       state.wishlist = [];
//       toast("User logged out successfully", { icon: "👋" });
//     },
//     updateUser: (state, action) => {
//       state.user = action.payload;
//       state.isAuthenticated = true;
//       localStorage.setItem("customer", JSON.stringify(action.payload));
//     },
//     syncLocalCart: (state, action) => {
//       state.cartProducts = action.payload || [];
//     },
//     clearCart: (state) => {
//       state.cartProducts = [];
//       toast.success("Your order will be placed successfully!");
//     },
//   },
//   extraReducers: (builder) => {
//     builder
//       .addCase(registerUser.fulfilled, (state, action) => {
//         state.isLoading = false;
//         state.isError = false;
//         state.isSuccess = true;
//         state.user = action.payload;
//         state.isAuthenticated = true;
//         localStorage.setItem("customer", JSON.stringify(action.payload));
//         toast.success("Please Login to Continue");
//         toast.success("User registered successfully");
//       })
//       .addCase(registerUser.rejected, (state, action) => {
//         state.isLoading = false;
//         state.isError = true;
//         state.message = action.payload;
//         toast.error(action.payload);
//       })
//       .addCase(loginUser.fulfilled, (state, action) => {
//         state.isLoading = false;
//         state.isError = false;
//         state.isSuccess = true;
//         state.user = action.payload.user;
//         state.isAuthenticated = true;
//         state.cartProducts = Array.isArray(action.payload.cart)
//           ? action.payload.cart
//           : action.payload.cart.cart || [];
//         state.wishlist = Array.isArray(action.payload.wishlist)
//           ? action.payload.wishlist
//           : action.payload.wishlist.wishlist || [];
//         localStorage.setItem("customer", JSON.stringify(action.payload.user));
//         toast.success("User logged in successfully");
//         console.log("loginUser - Fulfilled: state updated:", {
//           cartProducts: state.cartProducts,
//           wishlist: state.wishlist,
//           userProfile: state.userProfile,
//           orders: state.orders,
//         });
//       })
//       .addCase(loginUser.rejected, (state, action) => {
//         state.isLoading = false;
//         state.isError = true;
//         state.message = action.payload;
//         toast.error(action.payload);
//       })
//       .addCase(addProdToCart.rejected, (state, action) => {
//         state.isLoading = false;
//         state.isError = true;
//         state.message = action.payload;
//         toast.error(action.payload);
//       })
//       .addCase(getUserCart.rejected, (state, action) => {
//         state.isLoading = false;
//         state.isError = true;
//         state.message = action.payload;
//         toast.error(action.payload);
//       })
//       .addCase(getUserCart.fulfilled, (state, action) => {
//         state.isLoading = false;
//         state.isError = false;
//         state.isSuccess = true;
//         state.cartProducts = Array.isArray(action.payload) ? action.payload : action.payload.cart || [];
//         console.log("getUserCart - Fulfilled: cartProducts updated:", state.cartProducts);
//       })
//       .addCase(getUserProductWishlist.fulfilled, (state, action) => {
//         state.isLoading = false;
//         state.isError = false;
//         state.isSuccess = true;
//         state.wishlist = Array.isArray(action.payload) ? action.payload : action.payload.wishlist || [];
//         console.log("getUserProductWishlist - Fulfilled: wishlist updated:", state.wishlist);
//       })
//       .addCase(getUserProductWishlist.rejected, (state, action) => {
//         state.isLoading = false;
//         state.isError = true;
//         state.message = action.payload;
//         toast.error(action.payload);
//       })
//       .addCase(updateCartQuantity.fulfilled, (state) => {
//         state.isLoading = false;
//         toast.success("Quantity updated successfully!");
//       })
//       .addCase(updateCartQuantity.rejected, (state, action) => {
//         state.isLoading = false;
//         state.isError = true;
//         state.message = action.payload;
//         toast.error(action.payload);
//       });
//   },
// });

// export const { logout, updateUser, syncLocalCart, clearCart } = authSlice.actions;
// export default authSlice.reducer;


import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-hot-toast";
import { authService } from "./userService";

// Async Thunks
export const registerUser = createAsyncThunk(
  "auth/register",
  async (userData, thunkAPI) => {
    try {
      return await authService.register(userData);
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || error.message || "Registration failed";
      return thunkAPI.rejectWithValue(errorMessage);
    }
  }
);

export const loginUser = createAsyncThunk(
  "auth/login",
  async (userData, thunkAPI) => {
    try {
      console.log("🔐 Starting loginUser thunk...");
      console.log("📨 Received userData:", userData);

      const response = await authService.login(userData);
      console.log("✅ Login successful, response:", response);

      localStorage.setItem("customer", JSON.stringify(response));
      console.log("💾 Saved user to localStorage");

      let cartData = [];
      let wishlistData = [];

      // Only fetch cart and wishlist for non-deliveryboy users
      if (response.role !== 'deliveryboy') {
        const localCart = JSON.parse(localStorage.getItem("cart")) || [];
        console.log("🛒 Retrieved localCart from localStorage:", localCart);

        if (localCart.length > 0) {
          console.log("🔁 Syncing localCart to server...");
          for (const item of localCart) {
            console.log("📦 Adding item to server cart:", item);
            await thunkAPI.dispatch(addProdToCart(item)).unwrap();
            console.log("✅ Item added to server cart:", item);
          }
          localStorage.removeItem("cart");
          console.log("🧹 Removed localCart from localStorage after sync");
        }

        console.log("📥 Fetching user cart and wishlist from server...");
        try {
          const [cartResult, wishlistResult] = await Promise.all([
            thunkAPI.dispatch(getUserCart()).unwrap(),
            thunkAPI.dispatch(getUserProductWishlist()).unwrap(),
          ]);
          cartData = cartResult || [];
          wishlistData = wishlistResult || [];
        } catch (error) {
          console.warn("⚠️ Failed to fetch cart or wishlist:", error);
        }
      } else {
        console.log("🚚 Skipping cart and wishlist fetch for delivery boy");
      }

      const result = {
        user: response,
        cart: Array.isArray(cartData) ? cartData : cartData.cart || [],
        wishlist: Array.isArray(wishlistData) ? wishlistData : wishlistData.wishlist || [],
      };
      console.log("🎯 Final payload to return:", result);

      return result;
    } catch (error) {
      const errorMessage =
        error?.response?.data?.message || error?.message || "Login failed";
      console.error("❌ loginUser Thunk - Error:", errorMessage);
      return thunkAPI.rejectWithValue(errorMessage);
    }
  }
);

export const addProdToCart = createAsyncThunk(
  "user/cart/add",
  async (cartData, thunkAPI) => {
    try {
      const response = await authService.addToCart(cartData);
      await thunkAPI.dispatch(getUserCart()).unwrap();
      return response;
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || error.message || "Failed to add to cart";
      return thunkAPI.rejectWithValue(errorMessage);
    }
  }
);

export const getUserCart = createAsyncThunk(
  "user/cart/get",
  async (_, thunkAPI) => {
    try {
      const cartData = await authService.getCart();
      console.log("getUserCart Thunk - Cart Data:", cartData);
      return cartData;
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || error.message || "Failed to fetch cart";
      console.error("getUserCart error:", errorMessage);
      return thunkAPI.rejectWithValue(errorMessage);
    }
  }
);

export const getUserProductWishlist = createAsyncThunk(
  "user/wishlist",
  async (_, thunkAPI) => {
    try {
      const wishlistData = await authService.getUserWishlist();
      console.log("getUserProductWishlist Thunk - Wishlist Data:", wishlistData);
      return wishlistData;
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || error.message || "Failed to fetch wishlist";
      console.error("getUserProductWishlist error:", errorMessage);
      return thunkAPI.rejectWithValue(errorMessage);
    }
  }
);

export const updateCartQuantity = createAsyncThunk(
  "user/cart/updateQuantity",
  async ({ cartItemId, quantity }, thunkAPI) => {
    try {
      const response = await authService.updateCartQuantity({ cartItemId, quantity });
      await thunkAPI.dispatch(getUserCart()).unwrap();
      return response;
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || error.message || "Failed to update cart quantity";
      return thunkAPI.rejectWithValue(errorMessage);
    }
  }
);

// Initial State
const getCustomerFromLocalStorage = localStorage.getItem("customer")
  ? JSON.parse(localStorage.getItem("customer"))
  : null;

const initialState = {
  user: getCustomerFromLocalStorage,
  isAuthenticated: !!getCustomerFromLocalStorage,
  cartProducts: [],
  wishlist: [],
  isError: false,
  isSuccess: false,
  isLoading: false,
  message: "",
};

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    logout: (state) => {
      localStorage.removeItem("customer");
      state.user = null;
      state.isAuthenticated = false;
      state.cartProducts = [];
      state.wishlist = [];
      toast("User logged out successfully", { icon: "👋" });
    },
    updateUser: (state, action) => {
      state.user = action.payload;
      state.isAuthenticated = true;
      localStorage.setItem("customer", JSON.stringify(action.payload));
    },
    syncLocalCart: (state, action) => {
      state.cartProducts = action.payload || [];
    },
    clearCart: (state) => {
      state.cartProducts = [];
      toast.success("Your order will be placed successfully!");
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(registerUser.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.user = action.payload;
        state.isAuthenticated = true;
        localStorage.setItem("customer", JSON.stringify(action.payload));
        toast.success("Please Login to Continue");
        toast.success("User registered successfully");
      })
      .addCase(registerUser.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
        toast.error(action.payload);
      })
      .addCase(loginUser.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.user = action.payload.user;
        state.isAuthenticated = true;
        state.cartProducts = Array.isArray(action.payload.cart)
          ? action.payload.cart
          : action.payload.cart?.cart || [];
        state.wishlist = Array.isArray(action.payload.wishlist)
          ? action.payload.wishlist
          : action.payload.wishlist?.wishlist || [];
        localStorage.setItem("customer", JSON.stringify(action.payload.user));
        toast.success("User logged in successfully");
        console.log("loginUser - Fulfilled: state updated:", {
          cartProducts: state.cartProducts,
          wishlist: state.wishlist,
          userProfile: state.userProfile,
          orders: state.orders,
        });
      })
      .addCase(loginUser.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
        toast.error(action.payload);
      })
      .addCase(addProdToCart.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
        toast.error(action.payload);
      })
      .addCase(getUserCart.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.cartProducts = Array.isArray(action.payload) ? action.payload : action.payload?.cart || [];
        console.log("getUserCart - Fulfilled: cartProducts updated:", state.cartProducts);
      })
      .addCase(getUserCart.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload || "Failed to fetch cart";
        state.cartProducts = [];
        console.log("getUserCart - Rejected:", state.message);
      })
      .addCase(getUserProductWishlist.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.wishlist = Array.isArray(action.payload) ? action.payload : action.payload?.wishlist || [];
        console.log("getUserProductWishlist - Fulfilled: wishlist updated:", state.wishlist);
      })
      .addCase(getUserProductWishlist.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload || "Failed to fetch wishlist";
        state.wishlist = [];
        console.log("getUserProductWishlist - Rejected:", state.message);
      })
      .addCase(updateCartQuantity.fulfilled, (state) => {
        state.isLoading = false;
        toast.success("Quantity updated successfully!");
      })
      .addCase(updateCartQuantity.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
        toast.error(action.payload);
      });
  },
});

export const { logout, updateUser, syncLocalCart, clearCart } = authSlice.actions;
export default authSlice.reducer;